import {
  Component,
  Input,
  OnInit,
  ChangeDetectionStrategy,
} from '@angular/core';
import { NgClass } from '@angular/common';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';

@Component({
  selector: 'app-wizard-steps',
  templateUrl: './wizard-steps.component.html',
  styleUrls: ['./wizard-steps.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgClass, FaIconComponent],
})
export class WizardStepsComponent implements OnInit {
  @Input() steps: string[] = [];
  @Input() currentStep: number = 0;

  constructor() {}

  ngOnInit(): void {}
}
